import React, { useId } from 'react';

type AmericanFlagProps = {
  className?: string;
};

function starPath(cx: number, cy: number, outer: number, inner: number): string {
  const points: string[] = [];
  for (let i = 0; i < 10; i += 1) {
    const angle = (Math.PI / 2) * -1 + (i * Math.PI) / 5;
    const r = i % 2 === 0 ? outer : inner;
    points.push(`${cx + Math.cos(angle) * r},${cy + Math.sin(angle) * r}`);
  }
  return `M ${points.join(' L ')} Z`;
}

/** 50-star canton layout (alternating 6 / 5 rows). */
function renderStars(cantonW: number, cantonH: number): React.ReactNode[] {
  const rows = [6, 5, 6, 5, 6, 5, 6, 5, 6];
  const rowH = cantonH / 9;
  const outer = rowH * 0.22;
  const inner = outer * 0.42;
  const stars: React.ReactNode[] = [];

  rows.forEach((count, row) => {
    const y = rowH * (row + 0.55);
    const cols = count === 6 ? 6 : 5;
    const xOffset = count === 5 ? cantonW / 12 : 0;
    const xStep = cantonW / 6;
    for (let col = 0; col < cols; col += 1) {
      const x = xOffset + xStep * (col + 0.5);
      stars.push(
        <path
          key={`${row}-${col}`}
          d={starPath(x, y, outer, inner)}
          fill="#ffffff"
        />,
      );
    }
  });

  return stars;
}

const AmericanFlag: React.FC<AmericanFlagProps> = ({ className }) => {
  const clipId = useId();
  const width = 570;
  const height = 300;
  const stripeH = height / 13;
  const cantonW = width * 0.4;
  const cantonH = stripeH * 7;

  const stripes: React.ReactNode[] = [];
  for (let i = 0; i < 13; i += 1) {
    stripes.push(
      <rect
        key={i}
        x={0}
        y={i * stripeH}
        width={width}
        height={stripeH}
        fill={i % 2 === 0 ? '#B22234' : '#FFFFFF'}
      />,
    );
  }

  return (
    <svg
      className={className}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="United States flag"
    >
      <defs>
        <clipPath id={clipId}>
          <rect x={0} y={0} width={width} height={height} rx={6} ry={6} />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        {stripes}
        <rect x={0} y={0} width={cantonW} height={cantonH} fill="#3C3B6E" />
        <g>{renderStars(cantonW, cantonH)}</g>
      </g>
    </svg>
  );
};

export default AmericanFlag;
